module.exports = __webpack_public_path__ + "static/media/checkmark.d2115e36.svg";